import React, { SVGProps } from 'react'

export const IconSlack = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#clip0_1501_10214)">
      <path
        d="M9.66602 6.66683C9.11268 6.66683 8.66602 6.22016 8.66602 5.66683V2.3335C8.66602 1.78016 9.11268 1.3335 9.66602 1.3335C10.2193 1.3335 10.666 1.78016 10.666 2.3335V5.66683C10.666 6.22016 10.2193 6.66683 9.66602 6.66683Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.666 6.6665H12.666V5.6665C12.666 5.11317 13.1127 4.6665 13.666 4.6665C14.2193 4.6665 14.666 5.11317 14.666 5.6665C14.666 6.21984 14.2193 6.6665 13.666 6.6665Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33398 9.3335C6.88732 9.3335 7.33398 9.78016 7.33398 10.3335V13.6668C7.33398 14.2202 6.88732 14.6668 6.33398 14.6668C5.78065 14.6668 5.33398 14.2202 5.33398 13.6668V10.3335C5.33398 9.78016 5.78065 9.3335 6.33398 9.3335Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33398 9.3335H3.33398V10.3335C3.33398 10.8868 2.88732 11.3335 2.33398 11.3335C1.78065 11.3335 1.33398 10.8868 1.33398 10.3335C1.33398 9.78016 1.78065 9.3335 2.33398 9.3335Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33398 9.6665C9.33398 9.11317 9.78065 8.6665 10.334 8.6665H13.6673C14.2207 8.6665 14.6673 9.11317 14.6673 9.6665C14.6673 10.2198 14.2207 10.6665 13.6673 10.6665H10.334C9.78065 10.6665 9.33398 10.2198 9.33398 9.6665Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.334 12.6665H9.33398V13.6665C9.33398 14.2198 9.78065 14.6665 10.334 14.6665C10.8873 14.6665 11.334 14.2198 11.334 13.6665C11.334 13.1132 10.8873 12.6665 10.334 12.6665Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66732 6.3335C6.66732 5.78016 6.22065 5.3335 5.66732 5.3335H2.33398C1.78065 5.3335 1.33398 5.78016 1.33398 6.3335C1.33398 6.88683 1.78065 7.3335 2.33398 7.3335H5.66732C6.22065 7.3335 6.66732 6.88683 6.66732 6.3335Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66602 3.3335H6.66602V2.3335C6.66602 1.78016 6.21935 1.3335 5.66602 1.3335C5.11268 1.3335 4.66602 1.78016 4.66602 2.3335C4.66602 2.88683 5.11268 3.3335 5.66602 3.3335Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1501_10214">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
